import type { ReactNode } from 'react';

export interface AlertProps {
  variant?: 'error' | 'success' | 'info';
  children: ReactNode;
}

/**
 * Accessible inline alert. Errors use role="alert" for immediate announcement;
 * non-error variants (e.g. a success confirmation) use role="status" instead,
 * since they are not urgent interruptions.
 */
export function Alert({ variant = 'error', children }: AlertProps) {
  const role = variant === 'error' ? 'alert' : 'status';

  return (
    <div className={`zs-alert zs-alert--${variant}`} role={role}>
      {children}
    </div>
  );
}
